// Format kickoff/start times as "MM/DD, HH:MM AM/PM"
export function formatKickoff(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '—';
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    let hours = d.getHours();
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12; if (hours === 0) hours = 12;
    // Abbreviated weekday (e.g., Mon) using locale-sensitive formatting
    const weekday = d.toLocaleDateString(undefined, { weekday: 'short' });
    return `${weekday}, ${mm}/${dd}, ${hours}:${minutes} ${ampm}`;
  } catch { return '—'; }
}
